// Single source of truth - import from shared JSON
import catalogData from './catalog.json';

export const PRICE_IDS: Record<string, string> = catalogData.PRICE_IDS;
export const PRICES: Record<string, string> = catalogData.PRICES;
export const DROP_LABEL = catalogData.DROP_LABEL;
